import { useEffect } from 'react';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { setSubscriptionProvider } from '@/lib/api';

/**
 * Subscription Provider Registrar
 * 
 * This component registers the subscription provider with the API client.
 * Must be rendered inside SubscriptionProvider to access subscription context.
 */
export function SubscriptionProviderRegistrar() {
  const { subscriptionId } = useSubscription();

  useEffect(() => {
    // Register subscription provider with axios
    setSubscriptionProvider(() => subscriptionId);
  }, [subscriptionId]);

  return null; // This component doesn't render anything
}
